"use strict";
import { findRouteByPath } from "pages/RouteDefinitions";
import { Helmet } from "react-helmet-async/lib/index";
import { useLocation } from "react-router-dom";
import { useSporeColors } from "ui/src";
export default function MetaData() {
  const location = useLocation();
  const { pathname } = location;
  const staticDescription = findRouteByPath(pathname)?.getDescription(pathname);
  const colors = useSporeColors();
  return <Helmet>
      <title>Topaz Dex</title>
      {staticDescription && <meta name="description" content={staticDescription} />}
      {staticDescription && <meta property="og:description" content={staticDescription} />}
      <meta
    name="description"
    content="Topaz Dex — the central DeFi and liquidity hub on BNB Smart Chain."
  />
      <meta
    name="framer-search-index"
    content="https://framerusercontent.com/sites/2IlKtWZPMqUqMPMiSXFItD/searchIndex-b9W1CbiNJLa6.json"
  />
      <meta
    name="framer-search-index-fallback"
    content="https://framerusercontent.com/sites/2IlKtWZPMqUqMPMiSXFItD/searchIndex-x350lgzjhWcR.json"
  />
      {
    /* Open Graph / Facebook */
  }
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Topaz Dex" />
      <meta
    property="og:description"
    content="Topaz Dex — the central DeFi and liquidity hub on BNB Smart Chain."
  />
      <meta property="og:image" content="/preview.jpg" />
      {
    /* Twitter */
  }
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Topaz Dex" />
      <meta
    name="twitter:description"
    content="Topaz Dex — the central DeFi and liquidity hub on BNB Smart Chain."
  />
      <meta name="twitter:image" content="/preview.jpg" />

      <link href="https://fonts.gstatic.com" rel="preconnect" crossOrigin="" />
      <meta name="robots" content="max-image-preview:large" />
      <link rel="canonical" href="https://app.topazdex.com" />
      <meta property="og:url" content="https://app.topazdex.com" />
      <style>{`
            html {
              ::-webkit-scrollbar-thumb {
                background-color: ${colors.surface3.val};
              }
              scrollbar-color: ${colors.surface3.val} ${colors.surface1.val};
            }
          `}</style>
    </Helmet>;
}
